import Button from "@kamae-apps/shared/old/Component/Button/Button"
import FileInput from "@kamae-apps/shared/old/Component/Input/FileInput"
import Select from "@kamae-apps/shared/old/Component/Input/Select"
import { useToast } from "@kamae-apps/shared/old/Component/Toast/Context"
import { errorToast, successToast } from "@kamae-apps/shared/old/Component/Toast/ToastBuilder"
import config from "@kamae-apps/shared/variable"
import { useEffect, useMemo, useState } from "react"
import { Partner } from "../../../../Types/Partner"

const PLAN_OPTIONS = [
  { value: "starter", name: "Starter" },
  { value: "essential", name: "Essential" },
]

export default function CompanyImport() {
  const toast = useToast()
  const [csv, setCSV] = useState<File | null>(null)
  const [partners, setPartners] = useState<Partner[]>([])
  const [partnerId, setPartnerId] = useState<number | null>(null)
  const [plan, setPlan] = useState<string | null>(null)

  useEffect(() => {
    const jwt = localStorage.getItem("jwt") ?? ""
    fetch(config.api + "/partners", {
      headers: { Authorization: "Bearer " + jwt },
    })
      .then(res => res.json())
      .then(setPartners)
      .catch(console.error)
  }, [])

  const partnerOptions = useMemo(() => partners.map(p => ({ value: p.id, name: p.name })), [partners])

  return (
    <div className={"m-8 flex flex-col items-center gap-4"}>
      <div
        className={"relative w-3/5"}
        style={{ zIndex: 20 }}
      >
        <Select
          options={partnerOptions}
          placeholder={"Partenaire"}
          className={"!mx-0 !w-full"}
          onChange={e => setPartnerId(parseInt(e.target.value))}
        />
      </div>
      <div
        className={"relative w-3/5"}
        style={{ zIndex: 10 }}
      >
        <Select
          options={PLAN_OPTIONS}
          placeholder={"Plan"}
          className={"!mx-0 !w-full"}
          onChange={e => setPlan(e.target.value)}
        />
      </div>
      <div className={"flex w-full justify-center gap-4"}>
        <FileInput setValue={setCSV} />
        <Button
          disabled={!csv || !partnerId || !plan}
          className={
            "border-primary text-primary hover:bg-primary disabled:border-primary-200 disabled:text-primary-200 px-8 py-2 transition-colors hover:text-white disabled:bg-white"
          }
          onClick={() => {
            const headers = new Headers()
            const jwt = localStorage.getItem("jwt") ?? ""
            headers.append("Authorization", "Bearer " + jwt)
            headers.append("Content-Type", "text/plain")
            fetch(config.api + `/companies/batch?partnerId=${partnerId}&plan=${plan}`, {
              method: "POST",
              body: csv,
              headers,
            })
              .then(res => {
                if (res.ok) {
                  toast.addToast(successToast("Demande de création d'entreprises prise en compte"))
                } else {
                  throw new Error("Non OK status")
                }
              })
              .catch(err => {
                console.error(err)
                toast.addToast(errorToast("Erreur lors de l'import des entreprises"))
              })
          }}
        >
          Valider
        </Button>
      </div>
    </div>
  )
}
